// API configuration
export const API_URL = import.meta.env.VITE_API_URL || '/api';

// Feature flags
export const FEATURES = {
  MULTIPLE_SUBSCRIPTIONS: false,
  ENABLE_FRUIT_SUBSCRIPTION: false,
  ENABLE_CAT_GRASS_SUBSCRIPTION: false,
  ENABLE_SUBSCRIPTION_PURCHASES: false,
  ENABLE_RENEWALS: false
};

// App constants
export const APP_CONSTANTS = {
  APP_NAME: 'Piika',
  COPYRIGHT: `© ${new Date().getFullYear()} Piika`
}; 